import { LoadingCircle } from "./LoadingCircle";
import React from "react";

const LoadingSpinnerComponent = () => {
  return (
    <div className="flex justify-center">
      <LoadingCircle />
      <p>Laster inn...</p>
    </div>
  );
};

export default LoadingSpinnerComponent;
